import React, { ReactElement } from 'react';
import { ThemeProvider as ThemeProviderInternal } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './theme-provider.styles.scss';

const ThemeProvider: ReactComponent = (props: ReactComponentProps): ReactElement => {
  const {
    theme,
    children,
  } = props;

  return (
    <ThemeProviderInternal theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProviderInternal>
  );
};

export default ThemeProvider;
